// AWS Cognito 설정
const awsConfig = {
  Auth: {
    Cognito: {
      region: 'ap-northeast-2', // 예: 'ap-northeast-2'
      userPoolId: 'ap-northeast-2_NioBNskOI',
      userPoolClientId: '7va5bs19g0bcj243i8bqrnlqsc',
    }
  }
};

export default awsConfig;
